import { Autocomplete, Box, Grid, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import EntryTable from "./EntryTable";
import { API, graphqlOperation } from "aws-amplify";
import { listAccountMasterWithoutBalance } from "../../../graphql/customQueries";
import { MoneyFormatv3 } from "../../../library/MoneyFormat";
import {
  getAccountBalance,
  getTransactionRelationWithAccountID,
  listAccountTransactionDetailsv2,
  listPartyInvoicePurchases,
} from "../../../graphql/queries";
import moment from "moment";
import { useSelector } from "react-redux";
import SaveEntryTable from "./SaveDetails";
import SelectVoucher from "./SelectVoucher";
import ListLinkedInvoices from "./ListLinkedInvoices";
import { display } from "../../../redux/reducers/sidebar";

function LinkToInvoices() {
  const userPreferenceAndFY = useSelector(
    (state) => state.userPrefrenceandReducer
  );

  const [invNo, setInvNo] = useState([]);
  const [paymentNo, setPaymentNo] = useState([]);
  const [closeEvent, setCloseEvent] = useState(false);
  const [newItemRowStatus, setNewItemRowStatus] = useState(true);
  const [isFocusItem, setIsFocusItem] = useState(false);
  const [ledgerAccount, setLedgerAccount] = useState([]);
  const [newValue, setNewValue] = useState("");
  const [linkedPayments, setLinkedPayments] = useState([]);
  const [data, setData] = useState({
    accountName: { label: "", value: "", AccountGroupID: "" },
    unlinkedInvAmount: 0,
    ledgerBalance: 0,
    unlinkedPayAmount: 0,
    errorStatus: {
      accountName: false,
    },
    errorFields: {
      accountName: "",
    },
  });
  const [items, setItems] = useState([]);
  const [editedItems, setEditedItems] = useState({
    date: "",
    invoiceNumber: {
      label: "",
      value: "",
      invAmt: 0,
      date: "",
      balancamt: 0,
      transactionTypeCD: "",
      vouchNo: "",
    },
    invoiceAmount: 0,
    paymentNumber: {
      label: "",
      value: "",
      payAmt: 0,
      date: "",
      balancamt: 0,
      transactionTypeCD: "",
      vouchNo: "",
    },
    paymentAmount: 0,
    linkedAmount: 0,
    unlinkedPaymentAmount: 0,
    invoiceBalanceAmount: 0,
    editable: true,
    new: true,
    order: 1,
  });
  async function getLedgerAccounts() {
    try {
      let arr = [];
      const res = await API.graphql(
        graphqlOperation(listAccountMasterWithoutBalance)
      );
      if (res?.data?.listAccountMaster !== null) {
        res?.data?.listAccountMaster.map((ele) => {
          if (ele.AccountGroupID === 15 || ele.AccountGroupID === 7) {
            arr.push({
              label: ele.AccountName,
              value: ele.AccountsID,
              AccountGroupID: ele.AccountGroupID,
            });
          }
        });
      }
      setLedgerAccount(arr);
    } catch (error) {
      console.log("error", error);
    }
  }
  function reset() {
    setData((prev) => ({
      ...prev,
      accountName: { label: "", value: "", AccountGroupID: "" },
      unlinkedInvAmount: 0,
      ledgerBalance: 0,
      unlinkedPayAmount: 0,
    }));
    setEditedItems((prev) => ({
      ...prev,
      date: "",
      invoiceNumber: {
        label: "",
        value: "",
        invAmt: 0,
        date: "",
        balancamt: 0,
        transactionTypeCD: "",
        vouchNo: "",
      },
      invoiceAmount: 0,
      paymentNumber: {
        label: "",
        value: "",
        payAmt: 0,
        date: "",
        balancamt: 0,
        transactionTypeCD: "",
        vouchNo: "",
      },
      paymentAmount: 0,
      linkedAmount: 0,
      unlinkedPaymentAmount: 0,
      invoiceBalanceAmount: 0,
      editable: true,
      new: true,
      order: 1,
    }));
  }
  async function getInvoicesAndPayments(obj) {
    try {
      const res = await API.graphql(
        graphqlOperation(listPartyInvoicePurchases, { AccountID: obj.value })
      );
      let invNo = [];
      let paymentAmount = 0;
      let invoieArr = res.data.listPartyInvoicePurchases;
      if (invoieArr !== null) {
        if (obj.AccountGroupID === 7) {
          invoieArr.map((ele) => {
            invNo.push({
              label: `${ele.VoucherNumber}
              ${moment.unix(ele?.EntryDate).format("DD-MM-YYYY")}
              ${MoneyFormatv3(ele.GrantTotalAmount)}
               ${MoneyFormatv3(ele.PurchaseBalanceDueAmount)}`,
              //   label:<div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}> <span style={{ width: "20%"}} >{ele.VoucherNumber}</span>
              //   <span style={{ width: "20%", marginLeft: 10 }}>{moment.unix(ele?.EntryDate).format("DD-MM-YYYY")}</span>
              //  <span style={{ width: "20%", marginLeft: 10 }}>{MoneyFormatv3(ele.GrantTotalAmount)}</span>
              //  <span style={{ width: "20%", marginLeft: 10 }} > {MoneyFormatv3(ele.PurchaseBalanceDueAmount)}</span></div>,
              value: ele.PurchaseID,
              vouchNo: ele.VoucherNumber,
              invAmt: Number(ele.GrantTotalAmount),
              date: moment.unix(ele?.EntryDate).format("DD-MM-YYYY"),
              balancamt: Number(ele.PurchaseBalanceDueAmount),
              initialInvAmt: Number(ele.GrantTotalAmount),
              transactionTypeCD: "SalesInvoice",
            });
          });
          setInvNo(invNo);
        } else {
          invoieArr.map((ele) => {
            invNo.push({
              label: `${ele.InvoiceNumber}
              ${moment.unix(ele?.InvoiceDate).format("DD-MM-YYYY")}
              ${MoneyFormatv3(ele.InvoiceAmount)}
              ${MoneyFormatv3(ele.InvoiceBalanceDueAmount)}`,
              // label:<div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}> <span style={{ width: "20%"}} >{ele.InvoiceNumber}</span>
              //   <span style={{ width: "20%", marginLeft: 10 }}>{moment.unix(ele?.InvoiceDate).format("DD-MM-YYYY")}</span>
              //  <span style={{ width: "20%", marginLeft: 10 }}>{MoneyFormatv3(ele.InvoiceAmount)}</span>
              //  <span style={{ width: "20%", marginLeft: 10 }} > {MoneyFormatv3(ele.InvoiceBalanceDueAmount)}</span></div>,
              value: ele.InvoiceID,
              vouchNo: ele.InvoiceNumber,
              invAmt: Number(ele.InvoiceAmount),
              date: moment.unix(ele?.InvoiceDate).format("DD-MM-YYYY"),
              balancamt: Number(ele.InvoiceBalanceDueAmount),
              initialInvAmt: Number(ele.InvoiceAmount),
              transactionTypeCD: "SalesInvoice",
            });
          });
          setInvNo(invNo);
        }
      }
      const resAccountTransactionDetails = await API.graphql(
        graphqlOperation(listAccountTransactionDetailsv2, {
          AccountID: obj.value,
        })
      );
      let voucherNo = [];
      let transactionArr =
        resAccountTransactionDetails.data.listAccountTransactionDetailsv2;
      if (transactionArr !== null) {
        transactionArr.map((ele) => {
          paymentAmount =
            Number(ele.DebitAmount) === 0
              ? Number(ele.CreditAmount)
              : Number(ele.DebitAmount);
          voucherNo.push({
            label: `${ele.VoucherNumber} 
              ${moment.unix(ele?.EnteredTimeStamp).format("DD-MM-YYYY")} 
              ${MoneyFormatv3(paymentAmount)} 
              ${MoneyFormatv3(paymentAmount)}`,
            vouchNo: ele.VoucherNumber,
            value: ele.TransactionID,
            payAmt: Number(paymentAmount),
            date: moment.unix(ele.EnteredTimeStamp).format("DD-MM-YYYY"),
            balancamt: Number(paymentAmount),
            initialPayAmt: Number(paymentAmount),
            transactionTypeCD: ele.TransactionTypeCD,
          });
        });
        setPaymentNo(voucherNo);
      }
      displayLinkedPaymentsAndInvoices(invNo, voucherNo, obj.value);
    } catch (error) {
      console.log("error", error);
    }
  }
  function DisplayLinkToInvoiceTable(arr, invNo, paymentNo) {
    let zeroInvVoucher = [];
    let zeroPaymentVoucher = [];
    let invoiceBalanceMap = {};
    let paymentBalanceMap = {};
    arr.map((ele) => {
      let invoiceNumber = ele.invoiceNumber;
      let invoiceBalanceAmount = Number(ele.invoiceBalanceAmount);
      if (!(invoiceNumber in invoiceBalanceMap)) {
        invoiceBalanceMap[invoiceNumber] = invoiceBalanceAmount;
      } else {
        if (invoiceBalanceAmount < invoiceBalanceMap[invoiceNumber]) {
          invoiceBalanceMap[invoiceNumber] = invoiceBalanceAmount;
        }
      }
      let paymentNumber = ele.paymentNumber;
      let unlinkedPaymentAmount = Number(ele.unlinkedPaymentAmount);
      if (!(paymentNumber in paymentBalanceMap)) {
        paymentBalanceMap[paymentNumber] = unlinkedPaymentAmount;
      } else {
        if (unlinkedPaymentAmount < paymentBalanceMap[paymentNumber]) {
          paymentBalanceMap[paymentNumber] = unlinkedPaymentAmount;
        }
      }
      if (Number(ele.invoiceBalanceAmount) === 0) {
        zeroInvVoucher.push(ele?.invoiceNumber);
      }
      if (Number(ele.unlinkedPaymentAmount) === 0) {
        zeroPaymentVoucher.push(ele?.paymentNumber);
      }
    });
    let filterInvNo = invNo.filter((ele) => {
      return !zeroInvVoucher.includes(ele.vouchNo);
    });
    filterInvNo = filterInvNo.map((ele) => {
      let invoiceNumber = ele.vouchNo;
      if (invoiceNumber in invoiceBalanceMap) {
        ele.balancamt = invoiceBalanceMap[invoiceNumber];
      }
      return ele;
    });
    filterInvNo.map((ele) => {
      arr.map((subele) => {
        if (ele?.vouchNo === subele?.invoiceNumber) {
          ele.invAmt = Number(ele.initialInvAmt);
          ele.label = `${ele.vouchNo}
                ${ele?.date}
                ${MoneyFormatv3(ele.invAmt)}
                ${MoneyFormatv3(ele.balancamt)}`;
          // ele.label = <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}><span style={{ width: "20%"}}>{ele.vouchNo}</span>
          // <span style={{ width: "20%", marginLeft: 10 }}>{ele?.date}</span>
          // <span style={{ width: "20%", marginLeft: 10 }}>{MoneyFormatv3(ele.invAmt)}</span>
          // <span style={{ width: "20%", marginLeft: 10 }}>{MoneyFormatv3(ele.balancamt)}</span></div>;
        }
      });
    });
    let filterPaymentNo = paymentNo.filter((ele) => {
      return !zeroPaymentVoucher.includes(ele.vouchNo);
    });
    filterPaymentNo = filterPaymentNo.map((ele) => {
      let paymentNumber = ele.vouchNo;
      if (paymentNumber in paymentBalanceMap) {
        ele.balancamt = paymentBalanceMap[paymentNumber];
      }
      return ele;
    });
    filterPaymentNo.map((ele) => {
      arr.map((subele) => {
        if (ele?.vouchNo === subele?.paymentNumber) {
          ele.label = `${ele.vouchNo}
                ${ele?.date} 
                ${MoneyFormatv3(ele.payAmt)} 
                ${MoneyFormatv3(ele.balancamt)}`;
        }
      });
    });
    setPaymentNo(filterPaymentNo);
    setInvNo(filterInvNo);
  }
  async function displayLinkedPaymentsAndInvoices(invNo, paymentNo, Id) {
    try {
      setNewItemRowStatus(true);
      let obj = [];
      let arr = [];
      let invoiceObj = {};
      let paymentObj = {};
      let previousInvoiceBalanceAmountMap = {};
      let previousUnlinkedPaymentBalanceAmountMap = {};
      const res = await API.graphql(
        graphqlOperation(getTransactionRelationWithAccountID, {
          AccountID: Id,
        })
      );
      const linkedPayments = res?.data?.getTransactionRelationWithAccountID;
      if (linkedPayments !== null) {
        setLinkedPayments(linkedPayments);
        linkedPayments.map((ele, index) => {
          invNo.map((inv) => {
            if (ele.ObjectID === inv?.value) {
              invoiceObj = {
                label: `${inv.vouchNo}
                ${inv?.date}
                ${MoneyFormatv3(inv?.invAmt)}
                ${MoneyFormatv3(inv?.balancamt)}`,
                //   label:<div  style={{ display: "flex", justifyContent: "space-between", width: "100%" }}><span style={{ width: "20%" }}>{inv.vouchNo}</span>
                // <span style={{ width: "20%", marginLeft: 10 }}>{inv?.date}</span>
                // <span style={{ width: "20%", marginLeft: 10 }}>{MoneyFormatv3(inv.invAmt)}</span>
                // <span style={{ width: "20%", marginLeft: 10 }}>{MoneyFormatv3(ele.balancamt)}</span></div>,
                vouchNo: inv?.vouchNo,
                value: inv?.value,
                invAmt: Number(inv?.invAmt),
                date: inv?.date,
                linkedAmount: Number(ele.LinkedAmount),
                balancamt: Number(inv?.invAmt),
                transactionTypeCD: inv?.transactionTypeCD,
              };
            }
          });
          paymentNo.map((pay) => {
            if (ele.TransactionID === pay?.value) {
              paymentObj = {
                label: `${pay.vouchNo} 
                ${pay?.date}
                ${MoneyFormatv3(pay.payAmt)}
                ${MoneyFormatv3(pay.balancamt)}`,
                vouchNo: pay?.vouchNo,
                value: pay?.value,
                payAmt: Number(pay?.payAmt),
                date: pay?.date,
                balancamt: Number(pay?.payAmt),
                linkedAmount: Number(ele.LinkedAmount),
                transactionTypeCD: pay?.transactionTypeCD,
              };
            }
          });

          let invoiceBalanceAmount = 0;
          let unlinkedPaymentAmount = 0;

          if (
            index === 0 ||
            previousInvoiceBalanceAmountMap[invoiceObj.vouchNo] === undefined
          ) {
            // For the first occurrence of invoiceNumber or if no previous value exists in the map
            invoiceBalanceAmount =
              Number(invoiceObj?.invAmt) - Number(invoiceObj.linkedAmount);
          } else {
            // For subsequent rows with the same invoiceNumber, calculate based on previous value
            invoiceBalanceAmount =
              previousInvoiceBalanceAmountMap[invoiceObj.vouchNo] -
              Number(ele.LinkedAmount);
          }

          // Update the map with the current invoiceNumber and its calculated invoiceBalanceAmount
          previousInvoiceBalanceAmountMap[invoiceObj.vouchNo] =
            invoiceBalanceAmount;
          if (
            index === 0 ||
            previousUnlinkedPaymentBalanceAmountMap[paymentObj.vouchNo] ===
              undefined
          ) {
            // For the first occurrence of invoiceNumber or if no previous value exists in the map
            unlinkedPaymentAmount =
              Number(paymentObj?.payAmt) - Number(paymentObj.linkedAmount);
          } else {
            // For subsequent rows with the same invoiceNumber, calculate based on previous value
            unlinkedPaymentAmount =
              previousUnlinkedPaymentBalanceAmountMap[paymentObj.vouchNo] -
              Number(ele.LinkedAmount);
          }

          // Update the map with the current invoiceNumber and its calculated invoiceBalanceAmount
          previousUnlinkedPaymentBalanceAmountMap[paymentObj.vouchNo] =
            unlinkedPaymentAmount;
          obj = {
            ObjectID: invoiceObj?.value,
            TransactionID: paymentObj?.value,
            date: invoiceObj.date,
            invoiceNumber: invoiceObj.vouchNo,
            invoiceAmount: Number(invoiceObj?.invAmt),
            paymentNumber: paymentObj.vouchNo,
            paymentAmount: Number(paymentObj?.payAmt),
            linkedAmount: Number(ele.LinkedAmount),
            unlinkedPaymentAmount: Number(unlinkedPaymentAmount),
            invoiceBalanceAmount: Number(invoiceBalanceAmount),
            editable: false,
            new: false,
          };
          arr.push(obj);
        });
        DisplayLinkToInvoiceTable(arr, invNo, paymentNo);

        setItems(arr);
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  async function getBalance(id){
  try{  
  const res = await API.graphql(
    graphqlOperation(getAccountBalance, { AccountID: id })
  );

    setData((prev)=>({
      ...prev,
      ledgerBalance:res.data.getAccountBalance.AccountBalance
    }))
  
}catch(error){
  console.log("error",error);
}
}
  useEffect(() => {
    getLedgerAccounts();
  }, []);
  return (
    <Box
      sx={{
        padding: { xs: "80px 20px 20px 20px", sm: "70px 30px 20px 80px" },
        m: 1,
      }}
    >
      <Box
        sx={{
          borderRadius: "8px",
          backgroundColor: "background.paper",
          marginBottom: "10px",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          padding: { xs: "10px 0px", sm: "10px 10px" },
          borderRadius: "8px",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} lg={3} md={6}>
            <Autocomplete
              id="accountName"
              name="accountName"
              options={ledgerAccount}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              disableClearable
              value={data?.accountName}
              onChange={(e, newValue) => {
                reset();
                setNewValue(newValue);
                getBalance(newValue.value)
                getInvoicesAndPayments(newValue);
                setData((prev) => ({
                  ...prev,
                  accountName: newValue,
                  errorStatus: {
                    ...prev.errorStatus,
                    accountName: newValue ? false : true,
                  },
                  errorFields: {
                    ...prev.errorFields,
                    accountName: newValue
                      ? ""
                      : "Please Select the Ledger Account",
                  },
                }));
              }}
              size="small"
              renderInput={(params) => (
                <TextField
                  required={true}
                  error={data.errorStatus.accountName === true ? true : false}
                  sx={{
                    ".MuiFormLabel-asterisk": {
                      color: "danger.main",
                      fontSize: "16px",
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  {...params}
                  label="Ledger Account"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} lg={3} md={6}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px",
                borderRadius: "4px",
                backgroundColor: "#FFF",
                border: "2px solid rgba(224, 224, 224, 1)",
                position: "relative",
                height: 20,
              }}
            >
              <Typography sx={{ color: "#808080" }}>
                <span>Balance as per Ledger A/c </span>
              </Typography>
              <Typography sx={{ color: "#808080" }}>
                <span style={{ ml: 5 }}>
                  ₹ {MoneyFormatv3(data.ledgerBalance)}
                </span>
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} lg={3} md={6}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px",
                borderRadius: "4px",
                backgroundColor: "#FFF",
                border: "2px solid rgba(224, 224, 224, 1)",
                position: "relative",
                height: 20,
              }}
            >
              <Typography sx={{ color: "#808080" }}>
                <span>
                  {data?.accountName?.AccountGroupID === 7
                    ? "Unlinked Purchase Balance"
                    : "Unlinked Invoice Balance"}
                </span>
              </Typography>
              <Typography sx={{ color: "#808080" }}>
                <span style={{ ml: 5 }}>
                  ₹ {MoneyFormatv3(data.unlinkedInvAmount)}
                </span>
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} lg={3} md={6}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px",
                borderRadius: "4px",
                backgroundColor: "#FFF",
                border: "2px solid rgba(224, 224, 224, 1)",
                position: "relative",
                height: 20,
              }}
            >
              <Typography sx={{ color: "#808080" }}>
                <span>
                  {data?.accountName?.AccountGroupID === 7
                    ? "Unlinked Payment Amount"
                    : "Unlinked Receipt Amount"}
                </span>
              </Typography>
              <Typography sx={{ color: "#808080" }}>
                <span style={{ ml: 5 }}>
                  ₹ {MoneyFormatv3(data.unlinkedPayAmount)}
                </span>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
      {/* <EntryTable
        items={items}
        editedItems={editedItems}
        tempItems={tempItems}
        setItems={setItems}
        setEditedItems={setEditedItems}
        settempItems={settempItems}
        invNo={invNo}
        setInvNo={setInvNo}
        paymentNo={paymentNo}
        setPaymentNo={setPaymentNo}
        setCloseEvent={setCloseEvent}
        closEvent={closeEvent}
        setNewItemRowStatus={setNewItemRowStatus}
        newItemRowStatus={newItemRowStatus}
        isFocusItem={isFocusItem}
        setIsFocusItem={setIsFocusItem}
        rowIndex={rowIndex}
        setRowIndex={setRowIndex}
        data={data}
        setData={setData}
        newValue={newValue}
      /> */}
      <SelectVoucher
        items={items}
        editedItems={editedItems}
        setEditedItems={setEditedItems}
        invNo={invNo}
        setInvNo={setInvNo}
        paymentNo={paymentNo}
        setPaymentNo={setPaymentNo}
        data={data}
        setData={setData}
      />
      <ListLinkedInvoices
        items={items}
        editedItems={editedItems}
        setItems={setItems}
        setEditedItems={setEditedItems}
        invNo={invNo}
        setInvNo={setInvNo}
        setPaymentNo={setPaymentNo}
        paymentNo={paymentNo}
        setCloseEvent={setCloseEvent}
        data={data}
        setData={setData}
        newValue={newValue}
        getInvoicesAndPayments={(obj) => getInvoicesAndPayments(obj)}
      />
      <SaveEntryTable
        data={data}
        items={items}
        editedItems={editedItems}
        getInvoicesAndPayments={(obj) => getInvoicesAndPayments(obj)}
      />
    </Box>
  );
}

export default LinkToInvoices;
